import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import {
  Observable,
  distinctUntilChanged,
  filter,
  map,
  of,
  take,
  tap,
} from 'rxjs';
import { CartService } from 'src/app/services/cart.service';
import { PermissionService } from 'src/app/services/permission.service';
import { AppPermissions } from 'src/app/types/permissions';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent implements OnInit {
  public readonly storeRelatedRoutes: string[] = ['store'];
  public readonly orderRelatedRoutes: string[] = ['cart', 'order-summary'];
  public readonly orderListRelatedRoutes: string[] = ['orders'];
  public readonly scanRelatedRoutes: string[] = ['scan'];

  public readonly currentRoute$: Observable<string>;
  public readonly cartAmount$: Observable<number> = of(0);
  public readonly permissions = AppPermissions;

  constructor(
    private readonly navCtrl: NavController,
    private readonly router: Router,
    private readonly cartService: CartService,
    public readonly permissionService: PermissionService
  ) {
    this.currentRoute$ = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => (e as NavigationEnd).urlAfterRedirects.replace('/', '')),
      distinctUntilChanged()
    );

    this.cartAmount$ = this.cartService.currentCart$.pipe(
      map((cart) =>
        cart.items.reduce((acc, e) => {
          acc += e.quantity;
          return acc;
        }, 0)
      )
    );
  }

  ngOnInit() {
    return;
  }

  onNavigate(route: string): void {
    this.navCtrl.navigateRoot(route);
  }
}
